import { dishCodeBadge } from './dishCode';

interface Props {
  name: string;
  code?: string | null;
  /** `sm` for cart lines, `md` for dish cards, `lg` for the product modal title. */
  size?: 'sm' | 'md' | 'lg';
  /** Waiter ticket rows (06-test-cases.md W-T-11/13) assert on this exact
   *  testid — omitted elsewhere, so every other caller is unaffected. */
  testId?: string;
}

const SIZE: Record<NonNullable<Props['size']>, string> = {
  sm: 'align-[1px] me-1.5 px-1.5 py-[3px] text-[11px]',
  md: 'align-[2px] me-1.5 px-1.5 py-[3px] text-[12px] sm:text-[13px]',
  lg: 'align-[3px] me-2 px-2 py-[4px] text-[14px]',
};

/** The catalogue code pinned in front of a dish name. Rendered as a solid tag
 * (ink fill, paper text) rather than a hairline outline so it stays readable
 * at a glance on any restaurant theme — both tokens flip together, so the
 * contrast holds on light and dark themes alike. */
export default function DishCodeTag({ name, code, size = 'md', testId }: Props) {
  const label = dishCodeBadge(name, code);
  if (!label) return null;
  return (
    <span
      data-testid={testId}
      className={`inline-block bg-ink text-paper rounded-[6px] font-mono font-bold tracking-[0.02em] leading-none ${SIZE[size]}`}
    >
      {label}
    </span>
  );
}
